<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    submitLabel: {
      type: String,
      required: true,
    },
  },
  emits: ['submit', 'cancel'],
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    name: { required },
    pixelId: { required, minLength: minLength(5) },
    accessToken: { required, minLength: minLength(10) },
  },
  data() {
    return {
      name: this.value.name || '',
      pixelId: this.value.pixel_id || '',
      accessToken: this.value.access_token || '',
      enabled: this.value.enabled !== undefined ? this.value.enabled : true,
      testMode: this.value.test_mode || false,
      testEventCode: this.value.test_event_code || '',
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', {
        name: this.name,
        pixel_id: this.pixelId,
        access_token: this.accessToken,
        enabled: this.enabled,
        test_mode: this.testMode,
        test_event_code: this.testEventCode,
      });
    },
  },
};
</script>

<template>
  <form class="flex flex-col w-full" @submit.prevent="onSubmit">
    <div class="w-full">
      <label :class="{ error: v$.name.$error }">
        {{ $t('META_CAPI_PIXELS.FORM.NAME.LABEL') }}
        <input
          v-model="name"
          type="text"
          name="name"
          :placeholder="$t('META_CAPI_PIXELS.FORM.NAME.PLACEHOLDER')"
          @input="v$.name.$touch"
        />
        <span v-if="v$.name.$error" class="message">
          {{ $t('META_CAPI_PIXELS.FORM.NAME.ERROR') }}
        </span>
      </label>

      <label :class="{ error: v$.pixelId.$error }">
        {{ $t('META_CAPI_PIXELS.FORM.PIXEL_ID.LABEL') }}
        <input
          v-model="pixelId"
          type="text"
          name="pixel_id"
          :placeholder="$t('META_CAPI_PIXELS.FORM.PIXEL_ID.PLACEHOLDER')"
          @input="v$.pixelId.$touch"
        />
        <span v-if="v$.pixelId.$error" class="message">
          {{ $t('META_CAPI_PIXELS.FORM.PIXEL_ID.ERROR') }}
        </span>
      </label>

      <label :class="{ error: v$.accessToken.$error }">
        {{ $t('META_CAPI_PIXELS.FORM.ACCESS_TOKEN.LABEL') }}
        <input
          v-model="accessToken"
          type="password"
          name="access_token"
          :placeholder="$t('META_CAPI_PIXELS.FORM.ACCESS_TOKEN.PLACEHOLDER')"
          @input="v$.accessToken.$touch"
        />
        <span v-if="v$.accessToken.$error" class="message">
          {{ $t('META_CAPI_PIXELS.FORM.ACCESS_TOKEN.ERROR') }}
        </span>
      </label>

      <div class="flex items-center gap-4 my-4">
        <label class="flex items-center gap-2 mb-0 cursor-pointer">
          <input v-model="enabled" type="checkbox" />
          {{ $t('META_CAPI_PIXELS.FORM.ENABLED.LABEL') }}
        </label>

        <label class="flex items-center gap-2 mb-0 cursor-pointer">
          <input v-model="testMode" type="checkbox" />
          {{ $t('META_CAPI_PIXELS.FORM.TEST_MODE.LABEL') }}
        </label>
      </div>

      <label v-if="testMode">
        {{ $t('META_CAPI_PIXELS.FORM.TEST_EVENT_CODE.LABEL') }}
        <input
          v-model="testEventCode"
          type="text"
          name="test_event_code"
          :placeholder="
            $t('META_CAPI_PIXELS.FORM.TEST_EVENT_CODE.PLACEHOLDER')
          "
        />
      </label>
    </div>

    <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
      <NextButton
        faded
        slate
        type="reset"
        :label="$t('META_CAPI_PIXELS.FORM.CANCEL')"
        @click.prevent="$emit('cancel')"
      />
      <NextButton
        type="submit"
        :disabled="v$.$invalid || isSubmitting"
        :is-loading="isSubmitting"
        :label="submitLabel"
      />
    </div>
  </form>
</template>
